export default __webpack_public_path__ + "static/media/License.496aa3ef.jpg";